import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import { Cookies } from 'react-cookie';
import axios from 'axios';

const initialState = {
    data: [],
    pages: 0,
    total: 0,
    current: 0,
    partner: {},
    error: null,
    sidebar: true,
    loading: false,
    mloading: false,
}

export const PartnerCreateReq = createAsyncThunk('PartnerCreateReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.post(`${BASEURL}/admin/partner/create`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                navigate('/admin/partner-list');
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const SinglePartnerReq = createAsyncThunk('SinglePartnerReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/partner/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const updatePartnerReq = createAsyncThunk('updatePartnerReq', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/admin/partner/update/${id}`,
            data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${cookies.get('auth')}`,
            }
        })
            .then((res) => {
                if (res?.data?.success) {
                    navigate('/admin/partner-list')
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const PartnerVerify = createAsyncThunk('PartnerVerify', async ({ id, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/partner/verify/${id}`,
            { headers: headers() })
            .then((res) => {
                dispatch(PartnerListReq({}))
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const PartnerListReq = createAsyncThunk('PartnerListReq', async ({ page, navigate, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/partner/list?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const PartnerDeleteReq = createAsyncThunk('PartnerDeleteReq', async ({ page, id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/partner/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(PartnerListReq({ page }))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const banUserReq = createAsyncThunk('banUserReq', async ({ id, role, page, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/user/ban/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(PartnerListReq({ role, page }))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const PartnerSlice = createSlice({
    name: 'partnerSlice',
    initialState: initialState,
    reducers: {
        isSide: (state, action) => {
            state.sidebar = action.payload
            return state
        },
    },
    extraReducers: (builder) => {
        builder.addCase(PartnerListReq.pending, (state, action) => {
            state.loading = true
            state.pages = 0
            state.total = 0
            state.current = 0
            state.data = []
            return state
        })
        builder.addCase(PartnerListReq.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data?.partners
            state.pages = action.payload.data?.pages
            state.total = action.payload.data?.total
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(PartnerListReq.rejected, (state, action) => {
            state.loading = false
            state.pages = 0
            state.total = 0
            state.current = 0
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase(SinglePartnerReq.pending, (state, action) => {
            state.loading = true
            state.partner = {}
            return state
        })
        builder.addCase(SinglePartnerReq.fulfilled, (state, action) => {
            state.loading = false
            state.partner = action.payload.data
            return state
        })
        builder.addCase(SinglePartnerReq.rejected, (state, action) => {
            state.loading = false
            state.partner = {}
            state.error = 'Error occured'
        })
        builder.addCase(updatePartnerReq.pending, (state, action) => {
            state.mloading = true
            state.partner = {}
            return state
        })
        builder.addCase(updatePartnerReq.fulfilled, (state, action) => {
            state.mloading = false
            state.partner = action.payload.data
            return state
        })
        builder.addCase(updatePartnerReq.rejected, (state, action) => {
            state.mloading = false
            state.partner = {}
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export const { isSide } = PartnerSlice.actions
export default PartnerSlice.reducer